CustomMapPin.prototype = new google.maps.OverlayView();


/** @constructor */
function CustomMapPin(bounds, baseImg, item, map) {

    this.item = item;
    
    // Now initialize all properties.
    this.bounds_ = bounds;
    this.image_ = item.iconUrl;
    this.baseImage_ = baseImg;
    this.map_ = map;
    this.id_ = item.ID;
    this.clickEvent = null;

    // Define a property to hold the image's div. We'll
    // actually create this div upon receipt of the onAdd()
    // method so we'll leave it null for now.
    this.div_ = null;

    // Explicitly call setMap on this overlay
    this.setMap(map);
}

CustomMapPin.prototype.onAdd = function () {

    var div = document.createElement('div');
    div.id = this.id_ + '__icon__svg';
    div.style.border = 'none';
    div.style.borderWidth = '0px';
    div.style.position = 'absolute';

    // Create the img element and attach it to the div.
    var img = document.createElement('img');
    img.src = this.baseImage_;
    //img.style.width = '60px';
    //img.style.height = '99px';
    img.style.position = 'absolute';
    img.style.top = '-80px';
    img.style.left = '-24px';

    div.appendChild(img);

    if (this.image_.endsWith('svg')) {
        loadExternalSvg(div.id, this.image_);
    } else {
        var icon = document.createElement('img');
        icon.src = this.image_;
        icon.style.width = '39px';
        icon.style.height = '39px';
        icon.style.position = 'absolute';
        icon.style.top = '-63px';
        icon.style.left = '-19px';

        div.appendChild(icon);
    }

    this.div_ = div;

    // Add the element to the "overlayImage" pane.
    var panes = this.getPanes();
    panes.overlayImage.appendChild(this.div_);
};

CustomMapPin.prototype.draw = function () {

    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    var overlayProjection = this.getProjection();

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
    var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

    // Resize the image's div to fit the indicated dimensions.
    var div = this.div_;
    div.style.left = sw.x + 'px';
    div.style.top = ne.y + 'px';
    div.style.width = (ne.x - sw.x) + 'px';
    div.style.height = (sw.y - ne.y) + 'px';

    var marker = this.marker;
    google.maps.event.addDomListener(div, "click", function (event) {
        
        google.maps.event.trigger(marker, "click");
    });
};

CustomMapPin.prototype.onRemove = function () {
    this.div_.parentNode.removeChild(this.div_);
};

// Set the visibility to 'hidden' or 'visible'.
CustomMapPin.prototype.hide = function () {
    if (this.div_) {
        // The visibility property must be a string enclosed in quotes.
        this.div_.style.visibility = 'hidden';
    }
};

CustomMapPin.prototype.show = function () {
    if (this.div_) {
        this.div_.style.visibility = 'visible';
    }
};

CustomMapPin.prototype.toggle = function () {
    if (this.div_) {
        if (this.div_.style.visibility === 'hidden') {
            this.show();
        } else {
            this.hide();
        }
    }
};

CustomMapPin.prototype.getPosition = function() {
    return this.bounds_.getSouthWest();
}

// Detach the map from the DOM via toggleDOM().
// Note that if we later reattach the map, it will be visible again,
// because the containing <div> is recreated in the overlay's onAdd() method.
CustomMapPin.prototype.toggleDOM = function () {
    if (this.getMap()) {
        // Note: setMap(null) calls OverlayView.onRemove()
        this.setMap(null);
    } else {
        this.setMap(this.map_);
    }
};

//CustomMapPin.prototype.addListener = function (name, callback) {
//    this.clickEvent = callback;
//}